module.exports = {
  footerText: `new-ships.com © ${(new　Date()).getFullYear()}`,
}
